// React
import React, { useRef, useState } from "react";

// External libraries
import { faUpload, faCircleExclamation, faFile } from "@fortawesome/sharp-solid-svg-icons";

// Internal
import { FontAwesome } from "../icons/icons";

// CSS
import "./file-uploader.css";

function FileUploaderError(props) {
    return (
        <label style={{ paddingTop: 8 }}>{props.Error}</label>
    )
}

function FileUploaderButton(props) {
    const selectFile = () => {
        if (typeof props.SelectFile === "function") {
            props.SelectFile();
        }
    };

    const getErrors = () => {
        return props.Errors.map((error, index) => {
            return (
                <FileUploaderError key={index} Error={error} />
            );
        });
    };

    if (props.Loading) {
        return (
            <label>{props.LoadingMessage || "Loading..."}</label>
        );
    }

    if (props.Errors && props.Errors.length > 0) {
        return (
            <React.Fragment>
                <FontAwesome Icon={props.ErrorIcon || faCircleExclamation} Size="3x" />
                <div className="eone-ui-file-uploader-message">
                    {getErrors()}
                </div>
                <button type="button" onClick={selectFile} className="eone-ui-file-uploader-prompt">Change file</button>
            </React.Fragment>
        );
    }

    if (props.File) {
        return (
            <React.Fragment>
                <FontAwesome Icon={props.FileIcon || faFile} Size="3x" />
                <label className="eone-ui-file-uploader-message">{props.File}</label>
                <button type="button" onClick={selectFile} className="eone-ui-file-uploader-prompt">Replace file</button>
            </React.Fragment>
        );
    }

    if (props.Message) {
        if (props.Prompt) {
            return (
                <React.Fragment>
                    <FontAwesome Icon={props.Icon || faUpload} Size="3x" />
                    <label className="eone-ui-file-uploader-message">{props.Message}</label>
                    <button type="button" onClick={selectFile} className="eone-ui-file-uploader-prompt">{props.Prompt}</button>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <button type="button" onClick={selectFile} className="eone-ui-file-uploader-icon"><FontAwesome Icon={props.Icon || faUpload} Size="3x" /></button>
                <label className="eone-ui-file-uploader-message">{props.Message}</label>
            </React.Fragment>
        );
    }

    return (
        <button type="button" onClick={selectFile} className="eone-ui-file-uploader-icon"><FontAwesome Icon={props.Icon || faUpload} Size="3x" /></button>
    );
}

function FileUploader(props) {
    const [dragActive, setDragActive] = useState(false);
    const inputFile = useRef(null);

    const selectFile = () => {
        inputFile.current.value = []; // need to clear the value so selecting a file with the same name triggers the onchange
        inputFile.current.click();
    };

    const changeFile = (file) => {
        if (typeof props.ChangeFile === "function") {
            props.ChangeFile(file);
        }
    }

    const handleFileChange = (e) => {
        const fileObj = e.target.files && e.target.files[0];
        if (fileObj) {
            changeFile(e.target.files[0]);
        }
    };

    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            changeFile(e.dataTransfer.files[0]);
        }
    };

    const getClassName = () => {
        let className = "eone-ui-file-uploader-container";
        if (dragActive) {
            className = className + " eone-ui-file-uploader-container-dragging";
        }
        return className;
    }
    
    const getStyle = () => {
        if (props.Height) {
            return {
                height: props.Height
            }
        }
        return null;
    }

    if (props.Visible === false) {
        return null;
    }

    return (
        <div>
            <div className={getClassName()} style={getStyle()} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}>
                <FileUploaderButton
                    Icon={props.Icon}
                    File={props.File}
                    FileIcon={props.FileIcon}
                    Message={props.Message}
                    Prompt={props.Prompt}
                    Errors={props.Errors}
                    ErrorIcon={props.ErrorIcon}
                    Loading={props.Loading}
                    LoadingMessage={props.LoadingMessage}
                    SelectFile={selectFile} />
            </div>
            <input type='file' id='file' ref={inputFile} multiple={props.Multiple === true} onChange={handleFileChange} style={{ display: "none" }} />
        </div>
    );
}

export { FileUploader };